import { toPlatePlugin } from '@udecode/plate/react';

import { BaseStrikethroughPlugin } from '../lib/BaseStrikethroughPlugin';

export const StrikethroughPlugin = toPlatePlugin(BaseStrikethroughPlugin);
